import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useFilterFormsInstanceStore} from "presentation/stores/use-filter-formsinstance-store";

const HeaderFormsInstanceGrid: React.FC = () => {
  const [showModal, setShowModal] =
    useState(false);
     const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterFormsInstanceStore();
  const [currentGuid, setCurrentGuid] =
    useState<string | null>(null);

  const clearFilter = () => {
    resetFilters()
    setGlobalFilterValue("");
  };

const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  useEffect(() => {
    if (filters.query.value !== globalFilterValue) {
      setGlobalFilterValue(filters.query.value);
    }
  }, [filters]);

  const addFormInstance = () => {
    setCurrentGuid(null);
    setShowModal(true);
  };

  return (
    <div className="flex justify-content-between">

      <Dialog
        header="Criar Formulário"
        visible={showModal}
        onHide={() =>
          setShowModal(false)
        }
        style={{
          width: "70vw",
          maxHeight: "90vh",
        }}
        contentStyle={{
          overflowY: "auto",
        }}
      >
      </Dialog>

      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Procurar"
          />
        </IconField>
      </div>
      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};

export default HeaderFormsInstanceGrid;